// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Belt_Option = require("@rescript/runtime/lib/js/Belt_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function Callout$BaseCallout(props) {
  let onDismiss = props.onDismiss;
  let __size = props.size;
  let children = props.children;
  let size = __size !== undefined ? __size : "md";
  return JsxRuntime.jsxs("div", {
    children: [
      props.icon,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.title,
            className: size === "md" ? "text-zinc-700 font-semibold leading-5" : "text-zinc-700 font-medium leading-5 text-lg"
          }),
          children !== undefined ? JsxRuntime.jsx("div", {
              children: children
            }) : null
        ],
        className: "flex flex-col gap-2 flex-grow"
      }),
      onDismiss !== undefined ? JsxRuntime.jsx(ReactAriaComponents.Button, {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "cancel",
            className: "text-zinc-400"
          }),
          className: param => TailwindMerge.twMerge(["relative flex items-center before:content-[''] before:block before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:w-[42px] before:h-[42px] hover:cursor-pointer"]),
          onClick: param => onDismiss()
        }) : null
    ],
    className: TailwindMerge.twMerge([
      "flex flex-row gap-4 p-4 rounded-md border-l-[3px]",
      children === undefined ? "items-center" : "items-start",
      Belt_Option.getWithDefault(props.className, "")
    ])
  });
}

let BaseCallout = {
  make: Callout$BaseCallout
};

function Callout$Warning(props) {
  let icon = JsxRuntime.jsx(IconV5.make, {
    icon: "attention",
    size: 20,
    className: "text-tan-gold-light"
  });
  return JsxRuntime.jsx(Callout$BaseCallout, {
    children: props.children,
    title: props.title,
    icon: icon,
    size: props.size,
    onDismiss: props.onDismiss,
    className: "bg-[#f7f1e5] border-l-tan-gold-light"
  });
}

let Warning = {
  make: Callout$Warning
};

function Callout$Info(props) {
  let icon = JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("svg", {
      children: JsxRuntime.jsxs("g", {
        children: [
          JsxRuntime.jsx("path", {
            d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z",
            fill: "currentColor"
          }),
          JsxRuntime.jsx("rect", {
            height: "7",
            width: "2",
            fill: "inherit",
            rx: "1",
            x: "11",
            y: "10"
          }),
          JsxRuntime.jsx("circle", {
            cx: "12",
            cy: "8",
            fill: "inherit",
            r: "1"
          })
        ],
        fillRule: "evenodd"
      }),
      role: "presentation",
      height: "24",
      width: "24",
      viewBox: "0 0 24 24"
    }),
    className: "text-tan-blue-500 [fill:#e9eff3]"
  });
  return JsxRuntime.jsx(Callout$BaseCallout, {
    children: props.children,
    title: props.title,
    icon: icon,
    size: props.size,
    onDismiss: props.onDismiss,
    className: "bg-[#deebff] border-l-tan-blue-500"
  });
}

let Info = {
  make: Callout$Info
};

function Callout$Discovery(props) {
  let icon = JsxRuntime.jsx(IconV5.make, {
    icon: "light-bulb-alt",
    size: 30,
    className: "text-tan-blue-500"
  });
  return JsxRuntime.jsx(Callout$BaseCallout, {
    children: props.children,
    title: props.title,
    icon: icon,
    size: props.size,
    onDismiss: props.onDismiss,
    className: "bg-[#deebff] border-l-tan-blue-500"
  });
}

let Discovery = {
  make: Callout$Discovery
};

function Callout$Neutral(props) {
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.title,
        className: "text-zinc-700 font-medium leading-5"
      }),
      JsxRuntime.jsx("div", {
        children: children
      })
    ],
    className: "p-4 rounded-[6px] border border-zinc-300 flex flex-col gap-2"
  });
}

let Neutral = {
  make: Callout$Neutral
};

let Skeleton;

exports.BaseCallout = BaseCallout;
exports.Warning = Warning;
exports.Info = Info;
exports.Discovery = Discovery;
exports.Neutral = Neutral;
exports.Skeleton = Skeleton;
/* IconV5 Not a pure module */
